export function isUserProfileActive(userInfo) {
    if (!userInfo) return false;

    return (userInfo.displaylocation &&
        userInfo.firstname &&
        userInfo.surname &&
        userInfo.description &&
        userInfo.profilepicture &&
        userInfo.activeassetcount > 0);
}